import Vue from 'vue'
import $ from 'jquery'

import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

const Automount = (name, vueClass, opts = {}) => {
  $(name).each((i, el) => {
    const extraProps = opts.props || {}
    const app = new Vue({
      el,
      render: h => h(vueClass, {
        props: {
          ...$(el).data(),
          extraProps
        }
      }),
      ...opts
    })
    app.name = name
  })
}

export default Automount
